import type { Dispatch, FunctionComponent, ReactNode, RefObject, SetStateAction } from "react";
import { createContext, useContext, useRef } from "react";

import type { PercentageReached } from "./hooks";
import { usePercentageIntersect } from "./hooks";

type ContextValue = {
  articleElementReference?: RefObject<HTMLDivElement>;
  percentageReached?: PercentageReached;
  setPercentageReached?: Dispatch<SetStateAction<PercentageReached>>;
};

type Props = {
  children: ReactNode;
};

const ArticleRenderContext = createContext<ContextValue>({});

export const ArticleRenderContextProvider: FunctionComponent<Props> = ({ children }) => {
  const articleElementReference = useRef<HTMLDivElement>(null);
  const { percentageReached, setPercentageReached } =
    usePercentageIntersect(articleElementReference);
  return (
    <ArticleRenderContext.Provider
      value={{
        articleElementReference,
        percentageReached,
        setPercentageReached,
      }}
    >
      {children}
    </ArticleRenderContext.Provider>
  );
};

export const useArticleRenderContext = () => useContext(ArticleRenderContext);
